import { Size } from '@ps/web-core-enums';
import type { DrawLevel, ModLevels } from '@ps/web-shared-api-types/v1-preview/SwPkrSpinAndGo';
import { useScreenSize } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { PrizeDistributionModalTabs } from '../../../../types';
import { GameType, type GameTypeName } from '../../../../types/Game';
import GameCards from '../GameCards/GameCards';
import GameInfo from '../GameInfo/GameInfo';

export interface PrizeDistributionContentProps {
  selectedTab: PrizeDistributionModalTabs;
  playerCount: number[];
  weights: number[];
  buyIn: string;
  timeBank: number;
  initialChips: number;
  gameType: GameTypeName;
  modLevels: ModLevels[];
  drawLevels: DrawLevel[];
  currency: number;
  scalePM: number;
  buyin: number;
  rake: number;
  lowBet: number;
  highBet: number;
}

const PrizeDistributionContent: React.FC<PrizeDistributionContentProps> = ({
  selectedTab,
  playerCount,
  weights,
  buyIn,
  timeBank,
  initialChips,
  gameType,
  drawLevels,
  modLevels,
  currency,
  scalePM,
  buyin,
  rake,
  lowBet,
  highBet
}) => {
  const isMobile = useSelector(select.device.isMobile);
  const { greaterThan } = useScreenSize();
  const smallScreen = !greaterThan(Size.Small);
  const isSmallScreen = isMobile || smallScreen;
  const isHoldemMax = gameType === GameType.HoldemMax;
  const isInformationTabSelected = selectedTab === PrizeDistributionModalTabs.information;

  return (
    <>
      {((isInformationTabSelected && isSmallScreen) || isHoldemMax || !isSmallScreen) && (
        <GameCards
          buyIn={buyIn}
          timeBank={timeBank}
          players={modLevels?.[0].numUsers}
          chip={initialChips}
          tab={gameType}
          playerCount={playerCount}
          weights={weights}
          selectedTab={selectedTab}
          highBet={highBet}
          lowBet={lowBet}
        />
      )}
      {(!isInformationTabSelected || !isSmallScreen) && (
        <GameInfo
          currency={currency}
          gameType={gameType}
          rake={rake}
          scalePM={scalePM}
          buyIn={buyin}
          drawLevels={drawLevels}
          modLevels={modLevels}
          selectedTab={selectedTab}
          isSmallScreen={isSmallScreen}
        />
      )}
    </>
  );
};

export default PrizeDistributionContent;
